import { Link } from 'react-router-dom';

const footerLinks = {
  Product: [
    { to: '/product', label: 'Overview' },
    { to: '/features', label: 'Features' },
    { to: '/#', label: 'Pricing' },
    { to: '/#', label: 'Changelog' },
  ],
  Company: [
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
    { to: '/#', label: 'Careers' },
    { to: '/#', label: 'Blog' },
  ],
  Resources: [
    { to: '/#', label: 'Documentation' },
    { to: '/#', label: 'API Reference' },
    { to: '/#', label: 'Status' },
    { to: '/#', label: 'Security' },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a1a] border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <Link to="/" className="text-xl font-black text-white tracking-tight" style={{ fontFamily: 'Outfit' }}>
              <span className="text-[#00d4ff]">D</span>QP
            </Link>
            <p className="text-slate-500 text-sm mt-3 leading-relaxed">
              The AI-Native Data Intelligence Workbench. One platform to connect, discover, and query all your data.
            </p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-4" style={{ fontFamily: 'Outfit' }}>{title}</h4>
              <ul className="space-y-2">
                {links.map(l => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-slate-500 hover:text-slate-300 text-sm transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-xs">&copy; {new Date().getFullYear()} DQP Platform. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="text-slate-600 hover:text-slate-400 text-xs cursor-pointer transition-colors">Privacy Policy</span>
            <span className="text-slate-600 hover:text-slate-400 text-xs cursor-pointer transition-colors">Terms of Service</span>
            <span className="text-slate-600 hover:text-slate-400 text-xs cursor-pointer transition-colors">Cookie Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
